import createIcon from '../../createIcon';

/**
 * @component @name Grid4x4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgN1Y1SDE5VjJIMTdWNUgxM1YySDExVjVIN1YySDVWNUgyVjdINVYxMUgyVjEzSDVWMTdIMlYxOUg1VjIySDdWMTlIMTFWMjJIMTNWMTlIMTdWMjJIMTlWMTlIMjJWMTdIMTlWMTNIMjJWMTFIMTlWN0gyMlpNNyA3SDExVjExSDdWN1pNNyAxN1YxM0gxMVYxN0g3Wk0xNyAxN0gxM1YxM0gxN1YxN1pNMTcgMTFIMTNWN0gxN1YxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Grid4x4 = createIcon('Grid4x4', [
  [
    'path',
    {
      d: 'M22 7V5H19V2H17V5H13V2H11V5H7V2H5V5H2V7H5V11H2V13H5V17H2V19H5V22H7V19H11V22H13V19H17V22H19V19H22V17H19V13H22V11H19V7H22ZM7 7H11V11H7V7ZM7 17V13H11V17H7ZM17 17H13V13H17V17ZM17 11H13V7H17V11Z',
      key: 'fz29tf',
    },
  ],
]);

export default Grid4x4;
